import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import RibbonMenu from './RibbonMenu'
import EditorArea from './EditorArea'
import StatusBar from './StatusBar'
import AIAssistantPanel from './AIAssistantPanel'
import { DocumentProvider } from '../store/DocumentContext'

const DocumentEditor: React.FC = () => {
  const navigate = useNavigate()
  const [aiPanelOpen, setAiPanelOpen] = useState(true)

  return (
    <DocumentProvider>
      <div className="h-screen flex flex-col bg-white">
        {/* Top Bar */}
        <div className="bg-gray-800 text-white px-4 py-2 flex items-center justify-between">
          <div className="flex items-center gap-4">
            <button
              onClick={() => navigate('/')}
              className="text-gray-300 hover:text-white transition-colors"
            >
              ← Back to Home
            </button>
            <span className="text-sm text-gray-400">Legal Word Editor</span>
          </div>
          <div className="flex items-center gap-4">
            <button className="px-3 py-1 bg-gray-700 hover:bg-gray-600 rounded text-sm transition-colors">
              Open Docx File
            </button>
            <button className="px-3 py-1 bg-gray-700 hover:bg-gray-600 rounded text-sm transition-colors">
              New File
            </button>
            <button className="px-3 py-1 bg-gray-700 hover:bg-gray-600 rounded text-sm transition-colors">
              Export File
            </button>
            <button className="px-3 py-1 bg-gray-700 hover:bg-gray-600 rounded text-sm transition-colors">
              Settings
            </button>
            <button className="px-3 py-1 bg-gray-700 hover:bg-gray-600 rounded text-sm transition-colors">
              Security
            </button>
          </div>
        </div>

        {/* Document Title Bar */}
        <div className="bg-gray-100 border-b border-gray-200 px-4 py-2">
          <h1 className="text-lg font-semibold text-gray-900 text-center">Untitled Document.docx</h1>
        </div>

        {/* Ribbon Menu */}
        <RibbonMenu />

        {/* Main Content Area */}
        <div className="flex-1 flex">
          {/* Editor Area */}
          <div className="flex-1 flex flex-col overflow-y-auto">
            <EditorArea />
          </div>

          {/* AI Assistant Panel */}
          {aiPanelOpen && <AIAssistantPanel />}
        </div>

        {/* Status Bar */}
        <StatusBar />
      </div>
    </DocumentProvider>
  )
}

export default DocumentEditor
